import { render, staticRenderFns } from "./coberturas.vue?vue&type=template&id=4f2357f1&lang=html&"
import script from "./coberturas.vue?vue&type=script&lang=js&"
export * from "./coberturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports